import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Collapse, Form, Modal, Nav, Row, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import BuscadorSatModal from './BuscadorSatModal';

const PRECIOS_DEFAULT = [
    { vMoneda: 'MXN', idCatTipoPrecio: 1, descripcion: 'Pago Único',  dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
    { vMoneda: 'MXN', idCatTipoPrecio: 2, descripcion: 'Mensual',     dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
    { vMoneda: 'MXN', idCatTipoPrecio: 3, descripcion: 'Anual',       dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
    { vMoneda: 'USD', idCatTipoPrecio: 1, descripcion: 'Pago Único',  dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
    { vMoneda: 'USD', idCatTipoPrecio: 2, descripcion: 'Mensual',     dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
    { vMoneda: 'USD', idCatTipoPrecio: 3, descripcion: 'Anual',       dTotal: '', dPrecioUnitario: '', activo: false, vConfiguracionDescuentosJSON: null },
];

const AgregarProducto = ({ productos, precios: preciosExistentes, hideHeader = false, onSaved = null }) => {

    //const datos = productos.productos || productos; // Se asegura de que funcione en ambas estructuras*/

    const [datos, setDatos] = useState({
        idProducto: "0",
        idCatDepartamento: '',
        vCodigoBarras: "",
        vNombreProducto: "",
        dExistencia: "",
        dPrecioUnitario: "0",
        dTasaCuotaIVA: "0",
        vTipoFactorIVA: "",
        dIVA: "0",
        dTotal: "0",
        bServicio: '',
        dCreatedDate: "",
        vClaveUnidadSat: null,
        vCodigoProductoServicioSat: null,
        vImagenProducto_Base64: null,
        vImagenProducto_Name: null,
        bIsActive: '',
        vTipoProducto: "",
        idCatTipoProducto: null,
        idCatTipoLicencia: null,
        idCatModulo: null,
        iCantidadTimbres: "",
        bDescuentoPorDias: false,
        precios: PRECIOS_DEFAULT,
    });

    //const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [arrastrarImagen, setArrastrarImagen] = useState(false);
    const [imagenProducto, setImagenProducto] = useState({
        file: null
    });
    const [existencia, setDExistencia] = useState('')
    const [esActivo, setEsActivo] = useState('');
    const [tasaCuotaIVA, setTasaCuotaIVA] = useState("");
    const [claveDescripcion, setClaveDescripcion] = useState("");
    const [servicio, setServicio] = useState('');
    const [validarClave, setValidarClave] = useState({});
    const [validarCodigo, setValidarCodigo] = useState({});
    const [guardando, setGuardando] = useState(false);

    const [nuevoProducto, setNuevoProducto] = useState(true);
    const [showBuscadorProducto, setShowBuscadorProducto] = useState(false);
    const [showBuscadorUnidad, setShowBuscadorUnidad] = useState(false);
    const [tiposLicencia, setTiposLicencia] = useState([]);
    const [modulosDropdown, setModulosDropdown] = useState([]);
    const [moduloSeleccionado, setModuloSeleccionado] = useState(null);
    const [modulosPagina, setModulosPagina] = useState(1);
    const [modulosHayMas, setModulosHayMas] = useState(false);
    const [cargandoModulos, setCargandoModulos] = useState(false);
    const [moduloBusqueda, setModuloBusqueda] = useState('');
    const [showModuloDropdown, setShowModuloDropdown] = useState(false);
    const [showCrearModulo, setShowCrearModulo] = useState(false);
    const [guardandoModulo, setGuardandoModulo] = useState(false);
    const [nuevoModuloForm, setNuevoModuloForm] = useState({ vClaveModulo: '', vDescripcionModulo: '' });
    const debounceRefModulo = useRef(null);
    const [moduloAEliminar, setModuloAEliminar] = useState(null);
    const [eliminandoModulo, setEliminandoModulo] = useState(false);
    const [tabMoneda, setTabMoneda] = useState('MXN');
    const [errorTasaCuota, setErrorTasaCuota] = useState('');
    const [activeSection, setActiveSection] = useState(null); // 'basico' | 'sat' | 'media' | 'precios'

    // Estado para la configuración de descuentos
    const [showDescuentosModal, setShowDescuentosModal] = useState(false);
    const [descuentosConfig, setDescuentosConfig] = useState([]);
    const [descuentoPrecioSeleccionado, setDescuentoPrecioSeleccionado] = useState(null); // { vMoneda, idCatTipoPrecio, dTotal }

    const handleAbrirDescuentos = (precio) => {
        setDescuentoPrecioSeleccionado({ vMoneda: precio.vMoneda, idCatTipoPrecio: precio.idCatTipoPrecio, dTotal: precio.dTotal, descripcion: precio.descripcion });
        let configInicial = [];
        if (precio.vConfiguracionDescuentosJSON) {
            try {
                configInicial = JSON.parse(precio.vConfiguracionDescuentosJSON);
            } catch (e) {
                // Ignore parse error if JSON is invalid
            }
        }
        
        // Si no hay configuración inicial y el producto es Póliza, generar automáticamente las 3 reglas recomendadas (10%, 8%, 6%)
        if ((!configInicial || configInicial.length === 0) && (datos.vTipoProducto === 'Poliza' || datos.vTipoProducto === 'Póliza')) {
            const baseTotal = parseFloat(precio.dTotal) || 0;
            if (baseTotal > 0) {
                configInicial = [
                    { diasMin: 25, diasMax: 30, precio: (baseTotal * (1 - 0.10)).toFixed(2), porcentaje: '10' },
                    { diasMin: 15, diasMax: 24, precio: (baseTotal * (1 - 0.08)).toFixed(2), porcentaje: '8' },
                    { diasMin: 10, diasMax: 14, precio: (baseTotal * (1 - 0.06)).toFixed(2), porcentaje: '6' }
                ];
            }
        }

        setDescuentosConfig(configInicial);
        setShowDescuentosModal(true);
    };

    const handleAgregarDescuento = () => {
        setDescuentosConfig([...descuentosConfig, { diasMin: '', diasMax: '', precio: '', porcentaje: '' }]);
    };

    const handleEliminarDescuento = (index) => {
        setDescuentosConfig(descuentosConfig.filter((_, i) => i !== index));
    };

    const handleChangeDescuento = (index, field, value) => {
        const newConfig = [...descuentosConfig];
        const row = { ...newConfig[index], [field]: value };
        
        const dTotal = parseFloat(descuentoPrecioSeleccionado?.dTotal) || 0;
        
        // Recálculo cruzado
        if (field === 'precio' && dTotal > 0) {
            const parsedPrecio = parseFloat(value) || 0;
            if (parsedPrecio > 0) {
                row.porcentaje = (((dTotal - parsedPrecio) / dTotal) * 100).toFixed(2);
            } else {
                row.porcentaje = '';
            }
        } else if (field === 'porcentaje' && dTotal > 0) {
            const parsedPorc = parseFloat(value) || 0;
            if (parsedPorc > 0) {
                row.precio = (dTotal * (1 - (parsedPorc / 100))).toFixed(2);
            } else {
                row.precio = '';
            }
        }

        newConfig[index] = row;
        setDescuentosConfig(newConfig);
    };

    const handleGuardarDescuentos = () => {
        const newPrecios = datos.precios.map(p => {
            if (p.vMoneda === descuentoPrecioSeleccionado.vMoneda && p.idCatTipoPrecio === descuentoPrecioSeleccionado.idCatTipoPrecio) {
                return { ...p, vConfiguracionDescuentosJSON: JSON.stringify(descuentosConfig) };
            }
            return p;
        });
        setDatos({ ...datos, precios: newPrecios });
        setShowDescuentosModal(false);
    };

    useEffect(() => {

        validarProductos();
        cargarTiposLicencia();
        cargarTiposProducto();
    }, []);

    const [catTiposProducto, setCatTiposProducto] = useState([]);

    const cargarTiposProducto = async () => {
        try {
            const response = await fetch('/api/Productos/ObtenerCatTipoProducto', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error('Error al obtener tipos de producto');
            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detallesData = JSON.parse(data.detalles);
                if (detallesData.table2 && detallesData.table2.length > 0) {
                    setCatTiposProducto(detallesData.table2);
                }
            }
        } catch (error) {
            console.error('Error al cargar tipos de producto:', error);
            showErrorToast('Error al cargar tipos de producto');
        }
    };


    const cargarTiposLicencia = async () => {
        try {
            const response = await fetch('/api/Productos/ObtenerTiposLicencia', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Error al obtener tipos de licencia');
            }

            const data = await response.json();

            if (data.iResponseType === 1 && data.detalles) {
                // Parsear los detalles que vienen como JSON string
                const detallesData = JSON.parse(data.detalles);
                if (detallesData.table2 && detallesData.table2.length > 0) {
                    setTiposLicencia(detallesData.table2);
                }
            }
        } catch (error) {
            console.error('Error al cargar tipos de licencia:', error);
            showErrorToast('Error al cargar tipos de licencia');
        }
    };

    const eliminarModulo = async () => {
        if (!moduloAEliminar) return;
        setEliminandoModulo(true);
        try {
            const response = await fetch('/api/CatModulos/EliminarCatModulo', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                body: JSON.stringify({ idCatModulo: moduloAEliminar.idCatModulo })
            });
            const data = await response.json();
            if (data?.iResponseType === 1) {
                // Si el eliminado era el seleccionado, limpiar
                if (datos.idCatModulo === moduloAEliminar.idCatModulo) {
                    setDatos(prev => ({ ...prev, idCatModulo: null }));
                    setModuloSeleccionado(null);
                    setModuloBusqueda('');
                }
                setModulosDropdown(prev => prev.filter(m => m.idCatModulo !== moduloAEliminar.idCatModulo));
                setModuloAEliminar(null);
            } else {
                showErrorToast(data?.vMessage || 'Error al eliminar el módulo.');
            }
        } catch (error) {
            showErrorToast('Error al eliminar: ' + error);
        } finally {
            setEliminandoModulo(false);
        }
    };

    const cargarModulosDropdown = async (busqueda, pagina, append = false) => {
        setCargandoModulos(true);
        try {
            const params = new URLSearchParams({ pagina, porPagina: 10 });
            if (busqueda) params.append('busqueda', busqueda);
            const response = await fetch(`/api/CatModulos/ObtenerCatModulos?${params}`, {
                headers: { 'Authorization': 'Bearer ' + token }
            });
            if (!response.ok) return;
            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const lista = Array.isArray(detalles?.table2) ? detalles.table2 : [];
                const total = lista[0]?.iTotalRegistros ?? 0;
                if (append) {
                    setModulosDropdown(prev => [...prev, ...lista]);
                } else {
                    setModulosDropdown(lista);
                }
                setModulosHayMas((pagina * 10) < total);
                setModulosPagina(pagina);
            }
        } catch (error) {
            console.error('Error al cargar módulos:', error);
        } finally {
            setCargandoModulos(false);
        }
    };


    const validarProductos = async () => {

        if (productos != null && productos) {

            // Mapear precios existentes al formato de PRECIOS_DEFAULT
            const preciosArray = Array.isArray(preciosExistentes) ? preciosExistentes : [];

            const preciosFinales = PRECIOS_DEFAULT.map(p => {
                const match = preciosArray.find(
                    row => row.vMoneda === p.vMoneda && row.idCatTipoPrecio === p.idCatTipoPrecio
                );
                return match ? {
                    ...p,
                    dTotal: match.dTotal?.toString() ?? '',
                    dPrecioUnitario: match.dPrecioUnitario?.toString() ?? '',
                    vConfiguracionDescuentosJSON: match.vConfiguracionDescuentosJSON ?? null,
                    activo: true,
                } : p;
            });

            setDatos(prev => ({
                ...prev,
                ...productos,
                idCatTipoLicencia: productos.idCatTipoLicencia || null,
                idCatModulo: productos.idModuloVinculado || null,
                bDescuentoPorDias: productos.bDescuentoPorDias ?? false,
                precios: preciosFinales,
            }));

            // Cargar info del módulo vinculado si existe
            if (productos.idModuloVinculado) {
                try {
                    const resModulo = await fetch(`/api/CatModulos/ObtenerCatModulos?idCatModulo=${productos.idModuloVinculado}`, {
                        headers: { 'Authorization': 'Bearer ' + token }
                    });
                    if (resModulo.ok) {
                        const dModulo = await resModulo.json();
                        if (dModulo.iResponseType === 1 && dModulo.detalles) {
                            const det = JSON.parse(dModulo.detalles);
                            if (Array.isArray(det?.table2) && det.table2.length > 0) {
                                setModuloSeleccionado(det.table2[0]);
                                setModuloBusqueda(det.table2[0].vDescripcionModulo ?? '');
                            }
                        }
                    }
                } catch (e) { /* silent */ }
            }

            setServicio(productos.bServicio ? "1" : "0");
            setEsActivo(productos.bIsActive ? "1" : "0");
            setDExistencia(productos.bServicio === 1 ? '0' : productos.dExistencia);
            setTasaCuotaIVA(productos.dTasaCuotaIVA);
            setImagenProducto(prevState => ({
                ...prevState,
                file: productos.vImagenProducto_Base64
            }));
            setNuevoProducto(false);

            setValidarClave({
                validadoClaveUnidad: true,
                validandoClaveUnidad: false
            });
            setValidarCodigo({
                validadoCodigoSat: true,
                validandoCodigoSat: false
            });
        }
    }

    const crearModuloRapido = async () => {
        if (!nuevoModuloForm.vClaveModulo.trim() || !nuevoModuloForm.vDescripcionModulo.trim()) {
            showErrorToast('La clave y la descripción del módulo son obligatorias');
            return;
        }
        setGuardandoModulo(true);
        try {
            const response = await fetch('/api/CatModulos/InsUpdCatModulo', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    idCatModulo: null,
                    vClaveModulo: nuevoModuloForm.vClaveModulo.trim().toUpperCase(),
                    vDescripcionModulo: nuevoModuloForm.vDescripcionModulo.trim(),
                    bIsActive: true
                })
            });
            const data = await response.json();
            if (data?.iResponseType === 1) {
                const newId = parseInt(data.detalles);
                const moduloNuevo = {
                    idCatModulo: newId,
                    vClaveModulo: nuevoModuloForm.vClaveModulo.trim().toUpperCase(),
                    vDescripcionModulo: nuevoModuloForm.vDescripcionModulo.trim()
                };
                setDatos(prev => ({ ...prev, idCatModulo: newId }));
                setModuloSeleccionado(moduloNuevo);
                setModuloBusqueda(moduloNuevo.vDescripcionModulo);
                setModulosDropdown([]);
                setNuevoModuloForm({ vClaveModulo: '', vDescripcionModulo: '' });
                setShowCrearModulo(false);
                setShowModuloDropdown(false);
            } else {
                showErrorToast(data?.vMessage || 'Error al crear el módulo');
            }
        } catch (error) {
            showErrorToast('Error al crear el módulo: ' + error);
        } finally {
            setGuardandoModulo(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDatos({
            ...datos,
            [name]: value.toUpperCase(), // Convertir a mayúsculas
        });
    };

    // Función para actualizar el estado
    const actualizarClaveUnidad = (campo, valor) => {
        setDatos((prevState) => ({
            ...prevState,
            [campo]: valor,
        }));
        setValidarClave({
            validadoClaveUnidad: false,
            validandoClaveUnidad: false,
        });
    };

    // Función para actualizar el estado
    const actualizarCodigoProd = (campo, valor) => {
        setDatos((prevState) => ({
            ...prevState,
            [campo]: valor,
        }));

        setValidarCodigo({
            validadoCodigoSat: false,
            validandoCodigoSat: false,
        });
    };

    // Función para manejar cambios en el campo
    const tasaCuota = (e) => {
        const nuevaTasa = parseFloat(e.target.value || 0);
        setTasaCuotaIVA(nuevaTasa);
        calculaImpuestos(datos.vTipoFactorIVA, datos.dTotal, nuevaTasa);
    };


    const calculaImpuestos = async (TipoFactor, Total, tasaCuotaIVA) => {
        var iva = 0;
        var precioUnitario = 0;

        if (TipoFactor == "Tasa") {
            //iva = Total * tasaCuotaIVA;
            //precioUnitario = Total - iva;
            precioUnitario = Total / (1 + tasaCuotaIVA);
            iva = Total - precioUnitario;
        }

        if (TipoFactor == "Exento") {
            iva = 0;
            precioUnitario = Total;
        }

        if (TipoFactor == "Cuota") {
            iva = tasaCuotaIVA;
            precioUnitario = Total - tasaCuotaIVA;
        }

        var datos_ = datos;
        datos_.dPrecioUnitario = precioUnitario;
        datos_.dTasaCuotaIVA = iva;
        datos_.vTipoFactorIVA = TipoFactor;
        datos_.dTasaCuotaIVA = tasaCuotaIVA;
        datos_.dTotal = Total;

        //setDatos(datos_);
        setDatos({ ...datos, dIVA: iva, dPrecioUnitario: precioUnitario });
    }

    const calcularRenovacionesDesdeTasaCuota = () => {}; // eliminado — ya no se usa

    /**
     * Funcion para guardar un nuevo producto
     */
    const guardarProductos = async () => {

        if (datos.vClaveUnidadSat === null) {

            showErrorToast('Debes seleccionar una clave de unidad');
            return;
        }


        if (datos.idCatTipoProducto === "" || datos.idCatTipoProducto === null) {

            showErrorToast('Debes seleccionar el tipo de producto');
            return;
        }

        // Validar que si el tipo de producto es "Licencia", se haya seleccionado un tipo de licencia
        if (datos.vTipoProducto === "Licencia" && (!datos.idCatTipoLicencia || datos.idCatTipoLicencia === null)) {

            showErrorToast('Debes seleccionar un tipo de licencia');
            return;
        }

        // Validar que si el tipo de producto es "ModuloExtra", se haya seleccionado un módulo
        if (datos.vTipoProducto === "ModuloExtra" && (!datos.idCatModulo || datos.idCatModulo === null)) {
            showErrorToast('Debes seleccionar el módulo vinculado al producto');
            return;
        }

        // Validar que si el tipo de producto es "ModuloExtra", se haya seleccionado un tipo de licencia
        if (datos.vTipoProducto === "ModuloExtra" && (!datos.idCatTipoLicencia || datos.idCatTipoLicencia === null)) {
            showErrorToast('Debes seleccionar el tipo de licencia del módulo');
            return;
        }


        const preciosActivos = datos.precios.filter(p => p.activo);
        if (preciosActivos.length === 0) {
            showErrorToast('Debes activar al menos un precio para el producto');
            return;
        }
        for (const precio of preciosActivos) {
            if (!precio.dTotal || precio.dTotal.toString().trim() === '' || parseFloat(precio.dTotal) <= 0) {
                showErrorToast(`Debes ingresar un precio válido para ${precio.descripcion} (${precio.vMoneda})`);
                return;
            }
        }



        datos.vImagenProducto_Base64 = imagenProducto.file;
        console.log("imagen guardada")

        if (imagenProducto.file != null) {
            datos.vImagenProducto_Name = datos.vNombreProducto;
        }

        datos.bServicio = servicio;
        datos.bIsActive = esActivo;
        datos.dExistencia = existencia;
        datos.vClave = datos.vClaveUnidadSat;
        datos.dTasaCuotaIVA = tasaCuotaIVA;
        console.log("data guardarProductos", datos)

        setGuardando(true);

        const response = await fetch("/api/Productos/GuardarProductos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(datos)
            })
            .catch((error) => {

                setGuardando(false);
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("response (guardarProductos): ", response);
            const data = await response.json();
            console.log("data (guardarProductos2): ", data);


            if (data.iResponseType == 1) {
                // ✅ Éxito total (producto guardado + Stripe OK)
                showSuccessToast(data.vMessage);
                onSaved ? onSaved() : navigate('/productos/Catalogo')

            } else if (data.iResponseType == 3) {
                // ⚠️ Éxito con advertencias (producto guardado pero problemas con Stripe)

                // Parsear los detalles para obtener las advertencias
                let advertencias = [];
                let mensajeError = "";
                try {
                    const detalles = JSON.parse(data.detalles);
                    advertencias = detalles.advertencias || [];
                    mensajeError = detalles.mensajeError || "";
                } catch (e) {
                    console.error("Error parseando detalles:", e);
                }

                // Construir mensaje limpio y claro
                let mensajeCompleto = "PRODUCTO GUARDADO CORRECTAMENTE\n\n";
                mensajeCompleto += "ADVERTENCIA DE STRIPE:\n";
                mensajeCompleto += mensajeError + "\n";

                if (advertencias.length > 0) {
                    mensajeCompleto += advertencias.join("\n");
                }

                // Mostrar toast con estilo de advertencia
                showErrorToast(mensajeCompleto, {
                    autoClose: 12000, // 12 segundos para leer todo
                    style: {
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        border: '1px solid #ffc107',
                        whiteSpace: 'pre-line', // Respetar saltos de línea
                        padding: '15px',
                        fontSize: '14px',
                        lineHeight: '1.6'
                    }
                });

                console.warn("Advertencias de Stripe:", {
                    mensaje: mensajeError,
                    advertencias: advertencias
                });

                // Navegar al catálogo después de 2 segundos
                setTimeout(() => {
                    onSaved ? onSaved() : navigate('/productos/Catalogo');
                }, 2000);

            } else {
                // ❌ Error al guardar
                setGuardando(false);

                showErrorToast(data.vMessage);
                console.log("data_(guardarProductos error)", data.vMessage);
            }

        }
        else {
            setGuardando(false);

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";

            }
        }

    }

    // Selecciona el archivo de imagen
    const seleccionarImagen = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Validar tipo de archivo
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                console.error("Formatos permitidos: JPG, PNG");

                showErrorToast("Solo se permiten archivos JPG y PNG.");
                return;
            }

            // Validar extensión del archivo (case insensitive)
            const validExtensions = ['.jpg', '.jpeg', '.png'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                console.error("Extensiones permitidas: .jpg, .jpeg, .png");

                showErrorToast("Extensión no válida. Use JPG o PNG.");
                return;
            }

            // Validar longitud del nombre del archivo
            const MAX_NAME_LENGTH = 50;
            if (file.name.length > MAX_NAME_LENGTH) {
                console.error("Nombre demasiado largo");
                showErrorToast(`El nombre no debe exceder ${MAX_NAME_LENGTH} caracteres.`);
                return;
            }

            // Validar tamaño del archivo (2 MB = 2 * 1024 * 1024 bytes)
            const MAX_FILE_SIZE = 2 * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE) {
                console.error("Tamaño excedido");
                showErrorToast("El tamaño máximo permitido es 2MB.");
                return;
            }


            // Si todas las validaciones son correctas, procesar el archivo
            procesarArchivo(file, setImagenProducto);
        }
    };

    /**
    * Procesa la imagen
    */
    const procesarArchivo = (file, setArchivo) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const base64String = event.target.result.split(",")[1];
            setArchivo({
                fileName: file.name,
                file: base64String
            });
            console.log("ARCHIVO Y NOMBRE", { fileName: file.name, file: base64String }); // Para depuración
        };

        reader.onerror = () => {
            console.error("Error al leer el archivo.");
        };

        reader.readAsDataURL(file);
    };

    // Manejar arrastrar archivos
    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragover" || e.type === "dragenter") {
            setArrastrarImagen(true);
        } else if (e.type === "dragleave") {
            setArrastrarImagen(false);
        }
    }, []);

    // Manejar soltar archivos
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setArrastrarImagen(false);

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            seleccionarImagen({ target: { files } }); // Reutilizamos la misma función del input
        }
    }, [seleccionarImagen]);

    const borrarImagen = () => {
        // Limpiar el estado de la imagen
        setDatos((prevDatos) => ({
            ...prevDatos,
            vImagenProducto_Name: '', // Limpiar el nombre de la imagen
            vImagenProducto: null,    // Limpiar el archivo de la imagen
        }));

        // Limpiar el input de archivo
        const inputFile = document.getElementById('imagenProducto');
        if (inputFile) {
            inputFile.value = ''; // Restablecer el valor del input
        }

        // Si tienes un estado adicional para la imagen, también debes limpiarlo
        setImagenProducto({
            file: null
        });
    };

    const handleChangeTipoProducto = (e) => {
        const { value } = e.target;
        const selected = catTiposProducto.find(t => t.idCatTipoProducto === parseInt(value));
        const tipoDesc = selected ? selected.vTipoProducto : '';
        const esPol = (tipoDesc === 'Poliza' || tipoDesc === 'Póliza');
        setDatos({
            ...datos,
            idCatTipoProducto: value ? parseInt(value) : null,
            vTipoProducto: tipoDesc,
            bDescuentoPorDias: esPol ? datos.bDescuentoPorDias : false
        });
    };

    const handleChangeCantidadTimbres = (e) => {
        const valor = e.target.value;
        // Solo permitir números enteros (sin letras, puntos, comas, ni caracteres especiales)
        if (valor === '' || /^\d+$/.test(valor)) {
            setDatos({ ...datos, iCantidadTimbres: valor });
        }
        // Si no cumple la condición, simplemente no hace nada y el campo no se actualiza
    };


    const handleTogglePrecio = (vMoneda, idCatTipoPrecio) => {
        setDatos(prev => ({
            ...prev,
            precios: prev.precios.map(p =>
                p.vMoneda === vMoneda && p.idCatTipoPrecio === idCatTipoPrecio
                    ? { ...p, activo: !p.activo }
                    : p
            ),
        }));
    };

    const handlePrecioChange = (vMoneda, idCatTipoPrecio, valor) => {
        const totalNum = parseFloat(valor) || 0;
        const tasa = parseFloat(tasaCuotaIVA) || 0;
        let precioUnitario = totalNum;
        if (datos.vTipoFactorIVA === 'Tasa' && tasa > 0) {
            precioUnitario = totalNum / (1 + tasa);
        } else if (datos.vTipoFactorIVA === 'Cuota') {
            precioUnitario = totalNum - tasa;
        }
        setDatos(prev => ({
            ...prev,
            precios: prev.precios.map(p => {
                if (p.vMoneda === vMoneda && p.idCatTipoPrecio === idCatTipoPrecio) {
                    let nuevoJSON = p.vConfiguracionDescuentosJSON;
                    // Recalcular automáticamente los descuentos guardados si cambia el precio base y es Póliza
                    if (nuevoJSON && totalNum > 0 && (prev.vTipoProducto === 'Poliza' || prev.vTipoProducto === 'Póliza')) {
                        try {
                            const reglas = JSON.parse(nuevoJSON);
                            if (Array.isArray(reglas)) {
                                const reglasActualizadas = reglas.map(r => {
                                    const porc = parseFloat(r.porcentaje) || 0;
                                    const precCalc = (totalNum * (1 - (porc / 100))).toFixed(2);
                                    return { ...r, precio: precCalc };
                                });
                                nuevoJSON = JSON.stringify(reglasActualizadas);
                            }
                        } catch (e) {
                            // Ignore parse error if JSON is invalid
                        }
                    }
                    return { ...p, dTotal: valor, dPrecioUnitario: precioUnitario.toFixed(6), vConfiguracionDescuentosJSON: nuevoJSON };
                }
                return p;
            }),
        }));
    };

    const labelStyle = { fontSize: '0.65rem', letterSpacing: '0.07em' };
    const labelClass = 'text-uppercase text-muted fw-semibold mb-1';

    const botonesGuardar = (
        guardando ? (
            <Button variant="primary" size="sm" disabled>
                <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
                {datos.precios.some(p => p.activo && p.idCatTipoPrecio !== 1) && nuevoProducto
                    ? 'Creando en Stripe...'
                    : 'Guardando...'}
            </Button>
        ) : (
            <Button
                variant="primary"
                size="sm"
                disabled={
                    datos.vCodigoBarras === '' ||
                    datos.vNombreProducto === '' ||
                    datos.idCatDepartamento === '' ||
                    !datos.vClaveUnidadSat ||
                    !datos.vCodigoProductoServicioSat ||
                    (servicio !== '1' && existencia === '') ||
                    esActivo === '' ||
                    datos.vTipoFactorIVA === '' ||
                    datos.vTipoProducto === '' ||
                    (datos.vTipoProducto === 'Licencia' && !datos.idCatTipoLicencia) ||
                    (datos.vTipoProducto === 'ModuloExtra' && (!datos.idCatModulo || !datos.idCatTipoLicencia)) ||
                    datos.precios.filter(p => p.activo && p.dTotal && parseFloat(p.dTotal) > 0).length === 0
                }
                onClick={() => guardarProductos()}
            >
                <i className="bi bi-floppy me-2" />
                Guardar Producto
            </Button>
        )
    );

    return (
        <>
            {/* ── Header ────────────────────────────────────────── */}
            {!hideHeader && (
                <Card className="mb-3 px-3 py-2 shadow-sm">
                    {/* Fila 1: flecha + título */}
                    <Row className="align-items-center g-2 flex-nowrap mb-2">
                        <Col xs="auto">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                            />
                        </Col>
                        <Col xs="auto" className="d-none d-sm-block">
                            <img src="/img/ordenes96.png" alt="producto" height={36} />
                        </Col>
                        <Col className="min-w-0">
                            <h5 className="mb-0 fw-bold text-truncate">
                                {nuevoProducto ? 'Nuevo Producto' : 'Editar Producto'}
                            </h5>
                            <p className="text-muted mb-0 d-none d-md-block" style={{ fontSize: '0.78rem' }}>
                                {nuevoProducto
                                    ? 'Define los atributos y la estructura de precios del nuevo producto.'
                                    : 'Modifica los atributos y precios del producto.'}
                            </p>
                        </Col>
                        {/* Botones en desktop (md+) inline */}
                        <Col xs="auto" className="d-none d-md-flex gap-2 flex-shrink-0">
                            <Link to="/productos/Catalogo">
                                <Button variant="danger" size="sm" disabled={guardando}>
                                    Descartar
                                </Button>
                            </Link>
                            {botonesGuardar}
                        </Col>
                    </Row>
                    {/* Fila 2: botones en móvil (solo xs/sm) */}
                    <div className="d-flex d-md-none gap-2">
                        <Link to="/productos/Catalogo" className="flex-fill">
                            <Button variant="danger" size="sm" className="w-100" disabled={guardando}>
                                <i className="bi bi-x-circle me-1" />Descartar
                            </Button>
                        </Link>
                        <div className="flex-fill">
                            {guardando ? (
                                <Button variant="primary" size="sm" className="w-100" disabled>
                                    <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
                                    Guardando...
                                </Button>
                            ) : (
                                <Button
                                    variant="primary"
                                    size="sm"
                                    className="w-100"
                                    disabled={
                                        datos.vCodigoBarras === '' ||
                                        datos.vNombreProducto === '' ||
                                        datos.idCatDepartamento === '' ||
                                        !datos.vClaveUnidadSat ||
                                        !datos.vCodigoProductoServicioSat ||
                                        (servicio !== '1' && existencia === '') ||
                                        esActivo === '' ||
                                        datos.vTipoFactorIVA === '' ||
                                        datos.vTipoProducto === '' ||
                                        (datos.vTipoProducto === 'Licencia' && !datos.idCatTipoLicencia) ||
                                        (datos.vTipoProducto === 'ModuloExtra' && (!datos.idCatModulo || !datos.idCatTipoLicencia)) ||
                                        datos.precios.filter(p => p.activo && p.dTotal && parseFloat(p.dTotal) > 0).length === 0
                                    }
                                    onClick={() => guardarProductos()}
                                >
                                    <i className="bi bi-floppy me-1" />Guardar
                                </Button>
                            )}
                        </div>
                    </div>
                </Card>
            )}
            {hideHeader && (
                <div className="d-flex justify-content-end mb-3">
                    {botonesGuardar}
                </div>
            )}

            {/* ── Mobile: accordion de secciones (solo xs/sm) ─────── */}
            <div className="d-md-none">

                {/* Imágen del Producto */}
                <Card className="mb-2 shadow-sm overflow-hidden">
                    <div
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={() => setActiveSection(activeSection === 'media' ? null : 'media')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="min-w-0 me-2">
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-image text-primary" />
                                <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Imágen del Producto</span>
                            </div>
                            {activeSection !== 'media' && (
                                <div className="mt-1">
                                    {(datos.vImagenProducto_Name || imagenProducto.fileName)
                                        ? <span className="text-success" style={{ fontSize: '0.78rem' }}><i className="bi bi-check-circle-fill me-1" />{datos.vImagenProducto_Name || imagenProducto.fileName}</span>
                                        : <span className="text-muted fst-italic" style={{ fontSize: '0.78rem' }}>Sin imagen</span>
                                    }
                                </div>
                            )}
                        </div>
                        <i className={`bi bi-chevron-${activeSection === 'media' ? 'up' : 'down'} text-muted`} />
                    </div>
                    <Collapse in={activeSection === 'media'}>
                        <div>
                            <div className="px-3 pb-3 pt-2 border-top">
                                <div
                                    className={`border rounded-2 text-center p-3 ${arrastrarImagen ? 'border-primary bg-soft-primary' : ''}`}
                                    style={{ borderStyle: 'dashed', minHeight: '130px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                                    onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}
                                >
                                    <input type="file" id="imagenProductoMobile" onChange={seleccionarImagen} accept="image/*" className="d-none" />
                                    {imagenProducto.file ? (
                                        <img src={`data:image/png;base64,${imagenProducto.file}`} alt="preview" className="rounded-2 mb-2" style={{ maxWidth: '100%', maxHeight: '110px', objectFit: 'cover' }} />
                                    ) : (
                                        <>
                                            <i className="bi bi-cloud-upload text-400 mb-1" style={{ fontSize: '2rem', opacity: 0.4 }} />
                                            <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>{arrastrarImagen ? 'Suelta la imagen aquí' : 'Toca para subir una imagen'}</p>
                                            <p className="text-muted mb-0" style={{ fontSize: '0.7rem' }}>SVG, PNG, JPG · Máx. 2 MB</p>
                                        </>
                                    )}
                                    <label htmlFor="imagenProductoMobile" className="btn btn-outline-primary btn-sm mt-2" style={{ cursor: 'pointer', fontSize: '0.75rem' }}>
                                        Seleccionar imagen
                                    </label>
                                </div>
                                {(datos.vImagenProducto_Name || imagenProducto.fileName) && (
                                    <div className="d-flex align-items-center justify-content-between mt-2 p-2 rounded border">
                                        <span className="text-success small text-truncate me-2" style={{ fontSize: '0.75rem' }}>
                                            <i className="bi bi-check-circle-fill me-1" />{datos.vImagenProducto_Name || imagenProducto.fileName}
                                        </span>
                                        <button type="button" className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center" onClick={borrarImagen} title="Quitar imagen" style={{ width: '30px', height: '30px', flexShrink: 0 }}>
                                            <i className="bi bi-trash" style={{ fontSize: '0.85rem' }} />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Collapse>
                </Card>

                {/* Información Básica */}
                <Card className="mb-2 shadow-sm overflow-hidden">
                    <div
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={() => setActiveSection(activeSection === 'basico' ? null : 'basico')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="min-w-0 me-2">
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-info-circle text-primary" />
                                <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Información Básica</span>
                            </div>
                            {activeSection !== 'basico' && (
                                <div className="mt-1">
                                    {datos.vNombreProducto
                                        ? <span className="text-dark d-block" style={{ fontSize: '0.8rem' }}>{datos.vNombreProducto}</span>
                                        : <span className="text-muted fst-italic d-block" style={{ fontSize: '0.8rem' }}>Sin completar</span>
                                    }
                                    <div className="d-flex flex-wrap gap-1 mt-1">
                                        {datos.vTipoProducto && (
                                            <span className="badge bg-soft-primary text-primary" style={{ fontSize: '0.7rem' }}>{datos.vTipoProducto}</span>
                                        )}
                                        {datos.vTipoFactorIVA && (
                                            <span className="badge bg-soft-warning text-warning" style={{ fontSize: '0.7rem' }}>
                                                {datos.vTipoFactorIVA}{tasaCuotaIVA !== '' && tasaCuotaIVA !== '0' && tasaCuotaIVA !== 0 ? ` ${tasaCuotaIVA}` : ''}
                                            </span>
                                        )}
                                        {datos.vTipoProducto === 'Licencia' && datos.idCatTipoLicencia && tiposLicencia.length > 0 && (
                                            <span className="badge bg-soft-info text-info" style={{ fontSize: '0.7rem' }}>
                                                {tiposLicencia.find(t => t.idCatTipoLicencia === datos.idCatTipoLicencia)?.vDescripcionTipo || `Licencia #${datos.idCatTipoLicencia}`}
                                            </span>
                                        )}
                                        {datos.vTipoProducto === 'ModuloExtra' && datos.idCatModulo && (
                                            <span className="badge bg-soft-info text-info" style={{ fontSize: '0.7rem' }}>
                                                {moduloSeleccionado?.vDescripcionModulo || `Módulo #${datos.idCatModulo}`}
                                            </span>
                                        )}
                                        {datos.vTipoProducto === 'ModuloExtra' && datos.idCatTipoLicencia && tiposLicencia.length > 0 && (
                                            <span className="badge bg-soft-success text-success" style={{ fontSize: '0.7rem' }}>
                                                {tiposLicencia.find(t => t.idCatTipoLicencia === datos.idCatTipoLicencia)?.vDescripcionTipo || `Licencia #${datos.idCatTipoLicencia}`}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <i className={`bi bi-chevron-${activeSection === 'basico' ? 'up' : 'down'} text-muted`} />
                    </div>
                    <Collapse in={activeSection === 'basico'}>
                        <div>
                            <div className="px-3 pb-3 pt-2 border-top d-flex flex-column gap-3">
                                <div>
                                    <div className={labelClass} style={labelStyle}>Nombre del Producto</div>
                                    <Form.Control size="sm" autoComplete="off" name="vNombreProducto" type="text" value={datos.vNombreProducto} onChange={handleChange} placeholder="Nombre del producto" />
                                </div>
                                {servicio !== '1' && (
                                    <div>
                                        <div className={labelClass} style={labelStyle}>Existencia</div>
                                        <Form.Control size="sm" type="number" min="1" value={existencia} disabled={servicio === ''} onChange={(e) => setDExistencia(e.target.value)} placeholder="0" />
                                    </div>
                                )}
                                <div>
                                    <div className={labelClass} style={labelStyle}>Disponibilidad</div>
                                    <Form.Select size="sm" value={esActivo} onChange={(e) => setEsActivo(e.target.value)}>
                                        <option value=''>—</option>
                                        <option value="1">Disponible</option>
                                        <option value="0">No disponible</option>
                                    </Form.Select>
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Código de Barras</div>
                                    <Form.Control size="sm" autoComplete="off" type="text" name="vCodigoBarras" value={datos.vCodigoBarras} onChange={handleChange} placeholder="GTIN-13 / EAN" />
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Tipo de Producto</div>
                                    <Form.Select size="sm" value={datos.idCatTipoProducto || ''} onChange={handleChangeTipoProducto} name="idCatTipoProducto">
                                        <option value=''>Seleccionar</option>
                                        {catTiposProducto.map(tipo => (
                                            <option key={tipo.idCatTipoProducto} value={tipo.idCatTipoProducto}>
                                                {tipo.vDescripcion}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Tipo de Servicio</div>
                                    <Form.Select size="sm" value={servicio} onChange={(e) => { setServicio(e.target.value); if (e.target.value === '1') setDExistencia(0); else setDExistencia(datos ? datos.dExistencia : 0); }}>
                                        <option value=''>Seleccionar</option>
                                        <option value="1">Servicio</option>
                                        <option value="0">Inventariada</option>
                                    </Form.Select>
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Tipo de Factor IVA</div>
                                    <Form.Select size="sm" value={datos.vTipoFactorIVA} onChange={(e) => { const nf = e.target.value; setDatos(prev => ({ ...prev, vTipoFactorIVA: nf })); setTasaCuotaIVA(0); calculaImpuestos(nf, datos.dTotal, 0); calcularRenovacionesDesdeTasaCuota(nf, 0); }}>
                                        <option value=''>Seleccionar</option>
                                        <option value='Exento'>Exento</option>
                                        <option value='Tasa'>Tasa</option>
                                        <option value='Cuota'>Cuota</option>
                                    </Form.Select>
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Tasa o Cuota IVA</div>
                                    <Form.Control
                                        size="sm" type="number" step="any" min="0" value={tasaCuotaIVA}
                                        disabled={datos.vTipoFactorIVA === '' || datos.vTipoFactorIVA === 'Exento'}
                                        isInvalid={!!errorTasaCuota}
                                        onChange={(e) => { const v = parseFloat(e.target.value); if (datos.vTipoFactorIVA === 'Tasa' && v > 1) { setErrorTasaCuota('La tasa debe estar entre 0 y 1 (ej. 0.16)'); return; } if (datos.vTipoFactorIVA === 'Cuota' && v > 1000) { setErrorTasaCuota('La cuota no puede ser mayor a 1000'); return; } setErrorTasaCuota(''); tasaCuota(e); }}
                                        placeholder={datos.vTipoFactorIVA === 'Tasa' ? '0.16' : '0'}
                                    />
                                    {errorTasaCuota && <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>{errorTasaCuota}</div>}
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Comisión</div>
                                    <Form.Select size="sm" value={datos.idCatDepartamento} name="idCatDepartamento" onChange={handleChange}>
                                        <option value=''>Seleccionar</option>
                                        <option value='0'>Sin Comisión</option>
                                        <option value='1'>Comisión</option>
                                        <option value='2'>Comisión Parcial 30%</option>
                                    </Form.Select>
                                </div>
                                {datos.vTipoProducto === 'Licencia' && (
                                    <div>
                                        <div className={labelClass} style={labelStyle}>Tipo de Licencia</div>
                                        <Form.Select size="sm" value={datos.idCatTipoLicencia || ''} name="idCatTipoLicencia" onChange={(e) => setDatos(prev => ({ ...prev, idCatTipoLicencia: e.target.value ? parseInt(e.target.value) : null }))}>
                                            <option value=''>Seleccionar tipo</option>
                                            {tiposLicencia.map((tipo) => (
                                                <option key={tipo.idCatTipoLicencia} value={tipo.idCatTipoLicencia}>{tipo.vDescripcionTipo}</option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                )}
                                {datos.vTipoProducto === 'ModuloExtra' && (
                                    <div>
                                        <div className={labelClass} style={labelStyle}>Módulo Vinculado</div>
                                        <div style={{ position: 'relative' }}>
                                            <Form.Control
                                                size="sm"
                                                placeholder="Buscar módulo..."
                                                value={moduloBusqueda}
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    setModuloBusqueda(v);
                                                    setShowModuloDropdown(true);
                                                    if (!v) { setDatos(prev => ({ ...prev, idCatModulo: null })); setModuloSeleccionado(null); }
                                                    setModulosDropdown([]);
                                                    if (debounceRefModulo.current) clearTimeout(debounceRefModulo.current);
                                                    debounceRefModulo.current = setTimeout(() => cargarModulosDropdown(v, 1, false), 300);
                                                }}
                                                onFocus={() => {
                                                    setShowModuloDropdown(true);
                                                    if (modulosDropdown.length === 0) cargarModulosDropdown(moduloBusqueda, 1, false);
                                                }}
                                                onBlur={() => setTimeout(() => setShowModuloDropdown(false), 150)}
                                            />
                                            {datos.idCatModulo && !showModuloDropdown && (
                                                <div className="mt-1 d-flex align-items-center gap-2">
                                                    <span className="badge bg-soft-primary text-primary" style={{ fontSize: '0.7rem' }}>
                                                        {moduloSeleccionado?.vClaveModulo}
                                                    </span>
                                                    <small className="text-muted">{moduloSeleccionado?.vDescripcionModulo}</small>
                                                    <button type="button" className="btn-close" style={{ fontSize: '0.6rem' }}
                                                        onClick={() => { setDatos(prev => ({ ...prev, idCatModulo: null })); setModuloSeleccionado(null); setModuloBusqueda(''); }} />
                                                </div>
                                            )}
                                            {showModuloDropdown && (
                                                <div style={{ position: 'absolute', zIndex: 1000, width: '100%', background: 'white', border: '1px solid #dee2e6', borderRadius: '0.375rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                                                    {/* Deshabilitado para no crear módulos desde aquí
                                                    <div className="px-3 py-2 border-bottom" style={{ cursor: 'pointer', color: '#0d6efd', background: 'white' }}
                                                        onMouseDown={() => { setShowCrearModulo(true); setShowModuloDropdown(false); }}>
                                                        <i className="bi bi-plus-circle me-1" />Crear nuevo módulo...
                                                    </div>
                                                    */}
                                                    <div
                                                        style={{ maxHeight: '180px', overflowY: 'auto' }}
                                                        onScroll={(e) => {
                                                            const { scrollTop, clientHeight, scrollHeight } = e.target;
                                                            if (scrollHeight - scrollTop - clientHeight < 30 && modulosHayMas && !cargandoModulos) {
                                                                cargarModulosDropdown(moduloBusqueda, modulosPagina + 1, true);
                                                            }
                                                        }}
                                                    >
                                                        {modulosDropdown.map(mod => (
                                                            <div key={mod.idCatModulo} className="px-3 py-2 d-flex align-items-center justify-content-between" style={{ cursor: 'pointer' }}>
                                                                <div className="flex-grow-1 min-w-0"
                                                                    onMouseDown={() => { setDatos(prev => ({ ...prev, idCatModulo: mod.idCatModulo, vClaveModulo: mod.vClaveModulo })); setModuloSeleccionado(mod); setModuloBusqueda(mod.vDescripcionModulo); setShowModuloDropdown(false); }}>
                                                                    <span className="badge bg-soft-secondary text-secondary me-2" style={{ fontSize: '0.65rem' }}>{mod.vClaveModulo}</span>
                                                                    {mod.vDescripcionModulo}
                                                                </div>
                                                                {/* Deshabilitado para no borrar módulos
                                                                <button type="button" className="btn btn-link p-0 ms-2 text-danger" style={{ fontSize: '0.7rem', lineHeight: 1, flexShrink: 0 }}
                                                                    onMouseDown={(e) => { e.stopPropagation(); setModuloAEliminar(mod); setShowModuloDropdown(false); }}>
                                                                    <i className="bi bi-trash" />
                                                                </button>
                                                                */}
                                                            </div>
                                                        ))}
                                                        {cargandoModulos && (
                                                            <div className="text-center py-2">
                                                                <span className="spinner-border spinner-border-sm text-secondary" />
                                                            </div>
                                                        )}
                                                        {!cargandoModulos && modulosDropdown.length === 0 && (
                                                            <div className="px-3 py-2 text-muted" style={{ fontSize: '0.85rem' }}>Sin resultados</div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {showCrearModulo && (
                                            <div className="mt-2 p-2 border rounded" style={{ background: '#f8f9fa' }}>
                                                <div className="fw-semibold mb-2" style={{ fontSize: '0.8rem' }}>Nuevo módulo</div>
                                                <Form.Control size="sm" className="mb-2" placeholder="Clave (ej. MOD-FACTURACION-MX)"
                                                    value={nuevoModuloForm.vClaveModulo}
                                                    onChange={(e) => setNuevoModuloForm(prev => ({ ...prev, vClaveModulo: e.target.value.toUpperCase().replace(/[^A-Z0-9-_]/g, '') }))} />
                                                <Form.Control size="sm" className="mb-2" placeholder="Descripción del módulo"
                                                    value={nuevoModuloForm.vDescripcionModulo}
                                                    onChange={(e) => setNuevoModuloForm(prev => ({ ...prev, vDescripcionModulo: e.target.value }))} />
                                                <div className="d-flex gap-2">
                                                    <Button size="sm" variant="primary" onClick={crearModuloRapido} disabled={guardandoModulo}>
                                                        {guardandoModulo ? <><span className="spinner-border spinner-border-sm me-1" />Guardando...</> : 'Crear'}
                                                    </Button>
                                                    <Button size="sm" variant="outline-secondary" onClick={() => { setShowCrearModulo(false); setNuevoModuloForm({ vClaveModulo: '', vDescripcionModulo: '' }); }}>
                                                        Cancelar
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                        <div className="mt-2">
                                            <div className={labelClass} style={labelStyle}>Tipo de Licencia</div>
                                            <Form.Select size="sm" value={datos.idCatTipoLicencia || ''} name="idCatTipoLicencia"
                                                onChange={(e) => setDatos(prev => ({ ...prev, idCatTipoLicencia: e.target.value ? parseInt(e.target.value) : null }))}>
                                                <option value=''>Sin tipo de licencia</option>
                                                {tiposLicencia.map((tipo) => (
                                                    <option key={tipo.idCatTipoLicencia} value={tipo.idCatTipoLicencia}>{tipo.vDescripcionTipo}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                )}
                                {datos.vTipoProducto === 'PlanFacturacionMx' && (
                                    <div>
                                        <div className={labelClass} style={labelStyle}>Cantidad de Timbres</div>
                                        <Form.Control size="sm" type="text" value={datos.iCantidadTimbres} onChange={handleChangeCantidadTimbres} name="iCantidadTimbres" placeholder="Ej. 200" inputMode="numeric" pattern="[0-9]*" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Collapse>
                </Card>

                {/* Información SAT */}
                <Card className="mb-2 shadow-sm overflow-hidden">
                    <div
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={() => setActiveSection(activeSection === 'sat' ? null : 'sat')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="min-w-0 me-2">
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-receipt text-primary" />
                                <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Información SAT</span>
                            </div>
                            {activeSection !== 'sat' && (
                                <div className="mt-1">
                                    {datos.vClaveUnidadSat
                                        ? <span className="badge bg-soft-primary text-primary me-1" style={{ fontSize: '0.72rem' }}>{datos.vClaveUnidadSat}</span>
                                        : <span className="text-muted fst-italic" style={{ fontSize: '0.78rem' }}>Clave unidad pendiente</span>
                                    }
                                    {datos.vCodigoProductoServicioSat && (
                                        <span className="badge bg-soft-success text-success" style={{ fontSize: '0.72rem' }}>{datos.vCodigoProductoServicioSat}</span>
                                    )}
                                </div>
                            )}
                        </div>
                        <i className={`bi bi-chevron-${activeSection === 'sat' ? 'up' : 'down'} text-muted`} />
                    </div>
                    <Collapse in={activeSection === 'sat'}>
                        <div>
                            <div className="px-3 pb-3 pt-2 border-top d-flex flex-column gap-3">
                                <div>
                                    <div className={labelClass} style={labelStyle}>Clave Unidad SAT</div>
                                    <div className="d-flex gap-2">
                                        <Form.Control size="sm" value={datos.vClaveUnidadSat || ''} onChange={(e) => actualizarClaveUnidad('vClaveUnidadSat', e.target.value.trim())} placeholder="e.g. H87" isValid={validarClave.validadoClaveUnidad === true} isInvalid={validarClave.validadoClaveUnidad === false} />
                                        <Button variant="falcon-default" size="sm" onClick={(e) => { e.stopPropagation(); setShowBuscadorUnidad(true); }}>
                                            <FontAwesomeIcon icon="search" />
                                        </Button>
                                    </div>
                                    {validarClave.validadoClaveUnidad === false && <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>Seleccione o valide una clave</div>}
                                </div>
                                <div>
                                    <div className={labelClass} style={labelStyle}>Código Producto / Servicio SAT</div>
                                    <div className="d-flex gap-2">
                                        <Form.Control size="sm" value={datos.vCodigoProductoServicioSat || ''} onChange={(e) => actualizarCodigoProd('vCodigoProductoServicioSat', e.target.value.trim())} placeholder="e.g. 43231500" isValid={validarCodigo.validadoCodigoSat === true} isInvalid={validarCodigo.validadoCodigoSat === false} />
                                        <Button variant="falcon-default" size="sm" onClick={(e) => { e.stopPropagation(); setShowBuscadorProducto(true); }}>
                                            <FontAwesomeIcon icon="search" />
                                        </Button>
                                    </div>
                                    {validarCodigo.validadoCodigoSat === false && <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>Seleccione o valide un código</div>}
                                    {validarCodigo.validadoCodigoSat && claveDescripcion && <div className="text-success mt-1" style={{ fontSize: '0.71rem' }}>{claveDescripcion}</div>}
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </Card>

                {/* Estructura de Precios */}
                <Card className="mb-3 shadow-sm overflow-hidden">
                    <div
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={() => setActiveSection(activeSection === 'precios' ? null : 'precios')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="min-w-0 me-2">
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-tags text-primary" />
                                <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Estructura de Precios</span>
                            </div>
                            {activeSection !== 'precios' && (
                                <div className="mt-1">
                                    {datos.precios.some(p => p.activo && p.dTotal)
                                        ? <div className="d-flex flex-wrap gap-1">
                                            {datos.precios.filter(p => p.activo && p.dTotal).map(p => (
                                                <span key={`sm-${p.vMoneda}-${p.idCatTipoPrecio}`} className="badge bg-primary" style={{ fontSize: '0.7rem' }}>
                                                    {p.vMoneda} {p.descripcion}
                                                </span>
                                            ))}
                                        </div>
                                        : <span className="text-muted fst-italic" style={{ fontSize: '0.78rem' }}>Sin precios configurados</span>
                                    }
                                </div>
                            )}
                        </div>
                        <i className={`bi bi-chevron-${activeSection === 'precios' ? 'up' : 'down'} text-muted`} />
                    </div>
                    <Collapse in={activeSection === 'precios'}>
                        <div>
                            <div className="px-3 pb-3 pt-2 border-top">
                                <Nav variant="tabs" className="mb-3">
                                    <Nav.Item>
                                        <Nav.Link active={tabMoneda === 'MXN'} onClick={(e) => { e.stopPropagation(); setTabMoneda('MXN'); }} style={{ cursor: 'pointer', fontSize: '0.85rem' }}>MXN</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link active={tabMoneda === 'USD'} onClick={(e) => { e.stopPropagation(); setTabMoneda('USD'); }} style={{ cursor: 'pointer', fontSize: '0.85rem' }}>USD</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <div className="d-flex flex-wrap gap-4 pb-3 mb-3 border-bottom">
                                    {datos.precios.filter(p => p.vMoneda === tabMoneda).map(precio => (
                                        <Form.Check
                                            key={`mchk-${precio.vMoneda}-${precio.idCatTipoPrecio}`}
                                            type="checkbox"
                                            id={`mchk-${precio.vMoneda}-${precio.idCatTipoPrecio}`}
                                            label={precio.descripcion}
                                            checked={precio.activo}
                                            onChange={() => handleTogglePrecio(precio.vMoneda, precio.idCatTipoPrecio)}
                                        />
                                    ))}
                                </div>
                                {datos.precios.some(p => p.vMoneda === tabMoneda && p.activo) ? (
                                    <div className="d-flex flex-column gap-3">
                                        {datos.precios.filter(p => p.vMoneda === tabMoneda && p.activo).map(precio => {
                                            const total = parseFloat(precio.dTotal) || 0;
                                            const tasa = parseFloat(tasaCuotaIVA) || 0;
                                            let base = total;
                                            if (datos.vTipoFactorIVA === 'Tasa' && tasa > 0) base = total / (1 + tasa);
                                            else if (datos.vTipoFactorIVA === 'Cuota') base = total - tasa;
                                            return (
                                                <div key={`mrow-${precio.vMoneda}-${precio.idCatTipoPrecio}`}>
                                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                                        <span className="badge bg-primary" style={{ fontSize: '0.72rem' }}>{precio.descripcion}</span>
                                                        {total > 0 && <span className="text-muted" style={{ fontSize: '0.78rem' }}>Unitario: {tabMoneda} {base.toFixed(2)}</span>}
                                                    </div>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">{tabMoneda}</span>
                                                        <Form.Control type="number" min="0.01" step="0.01" placeholder="0.00" value={precio.dTotal} onChange={e => handlePrecioChange(precio.vMoneda, precio.idCatTipoPrecio, e.target.value)} />
                                                        <Button variant="outline-secondary" size="sm" onClick={(e) => { e.stopPropagation(); handleAbrirDescuentos(precio); }} title="Configurar Descuentos">
                                                            <i className="bi bi-percent" />
                                                        </Button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="text-center py-3 text-muted" style={{ fontSize: '0.82rem' }}>
                                        <i className="bi bi-tag me-2 opacity-50" />
                                        Activa al menos un tipo de precio para continuar.
                                    </div>
                                )}
                            </div>
                        </div>
                    </Collapse>
                </Card>

            </div>

            {/* ── Body (desktop) ─────────────────────────────────── */}
            <Row className="g-3 align-items-start d-none d-md-flex">

                {/* ─── Columna izquierda: Media + SAT ──────────── */}
                <Col md={4} xl={3}>

                    {/* Imágen del Producto */}
                    <Card className="mb-3 shadow-sm">
                        <Card.Header className="py-2 px-3 border-bottom">
                            <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                <i className="bi bi-image me-2 text-primary" />
                                Imágen del Producto
                            </span>
                        </Card.Header>
                        <Card.Body className="p-3">
                            <div
                                className={`border rounded-2 text-center p-3 ${arrastrarImagen ? 'border-primary bg-soft-primary' : ''}`}
                                style={{ borderStyle: 'dashed', minHeight: '130px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                                onDragEnter={handleDrag}
                                onDragLeave={handleDrag}
                                onDragOver={handleDrag}
                                onDrop={handleDrop}
                            >
                                <input
                                    type="file"
                                    id="imagenProducto"
                                    onChange={seleccionarImagen}
                                    accept="image/*"
                                    className="d-none"
                                />
                                {imagenProducto.file ? (
                                    <img
                                        src={`data:image/png;base64,${imagenProducto.file}`}
                                        alt="preview"
                                        className="rounded-2 mb-2"
                                        style={{ maxWidth: '100%', maxHeight: '110px', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <>
                                        <i className="bi bi-cloud-upload text-400 mb-1" style={{ fontSize: '2rem', opacity: 0.4 }} />
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            {arrastrarImagen ? 'Suelta la imagen aquí' : 'Arrastra o haz clic para subir'}
                                        </p>
                                        <p className="text-muted mb-0" style={{ fontSize: '0.7rem' }}>
                                            SVG, PNG, JPG · Máx. 2 MB
                                        </p>
                                    </>
                                )}
                                <label
                                    htmlFor="imagenProducto"
                                    className="btn btn-outline-primary btn-sm mt-2"
                                    style={{ cursor: 'pointer', fontSize: '0.75rem' }}
                                >
                                    {arrastrarImagen ? 'Suelta aquí' : 'Seleccionar imagen'}
                                </label>
                            </div>

                            {(datos.vImagenProducto_Name || imagenProducto.fileName) && (
                                <div className="d-flex align-items-center justify-content-between mt-2 p-2 rounded border">
                                    <span className="text-success small text-truncate me-2" style={{ fontSize: '0.75rem' }}>
                                        <i className="bi bi-check-circle-fill me-1" />
                                        {datos.vImagenProducto_Name || imagenProducto.fileName}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                                        onClick={borrarImagen}
                                        title="Quitar imagen"
                                        style={{ width: '30px', height: '30px', flexShrink: 0 }}
                                    >
                                        <i className="bi bi-trash" style={{ fontSize: '0.85rem' }} />
                                    </button>
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    {/* Información SAT */}
                    <Card className="shadow-sm">
                        <Card.Header className="py-2 px-3 border-bottom">
                            <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                Información SAT
                            </span>
                        </Card.Header>
                        <Card.Body className="p-3">
                            <div className="mb-3">
                                <div className={labelClass} style={labelStyle}>Clave Unidad SAT</div>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        size="sm"
                                        value={datos.vClaveUnidadSat || ''}
                                        onChange={(e) => actualizarClaveUnidad('vClaveUnidadSat', e.target.value.trim())}
                                        placeholder="e.g. H87"
                                        isValid={validarClave.validadoClaveUnidad === true}
                                        isInvalid={validarClave.validadoClaveUnidad === false}
                                    />
                                    <Button variant="falcon-default" size="sm" onClick={() => setShowBuscadorUnidad(true)}>
                                        <FontAwesomeIcon icon="search" />
                                    </Button>
                                </div>
                                {validarClave.validadoClaveUnidad === false && (
                                    <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>
                                        Seleccione o valide una clave
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className={labelClass} style={labelStyle}>Código Producto / Servicio SAT</div>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        size="sm"
                                        value={datos.vCodigoProductoServicioSat || ''}
                                        onChange={(e) => actualizarCodigoProd('vCodigoProductoServicioSat', e.target.value.trim())}
                                        placeholder="e.g. 43231500"
                                        isValid={validarCodigo.validadoCodigoSat === true}
                                        isInvalid={validarCodigo.validadoCodigoSat === false}
                                    />
                                    <Button variant="falcon-default" size="sm" onClick={() => setShowBuscadorProducto(true)}>
                                        <FontAwesomeIcon icon="search" />
                                    </Button>
                                </div>
                                {validarCodigo.validadoCodigoSat === false && (
                                    <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>
                                        Seleccione o valide un código
                                    </div>
                                )}
                                {validarCodigo.validadoCodigoSat && claveDescripcion && (
                                    <div className="text-success mt-1" style={{ fontSize: '0.71rem' }}>
                                        {claveDescripcion}
                                    </div>
                                )}
                            </div>
                        </Card.Body>
                    </Card>

                </Col>

                {/* ─── Columna derecha: Info Básica + Precios ────── */}
                <Col md={8} xl={9}>

                    {/* Información Básica */}
                    <Card className="mb-3 shadow-sm">
                        <Card.Header className="py-2 px-3 border-bottom">
                            <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                <i className="bi bi-info-circle me-2 text-primary" />
                                Información Básica
                            </span>
                        </Card.Header>
                        <Card.Body className="p-3">

                            {/* Fila 1: Nombre | Existencia | Disponible */}
                            <Row className="g-3">
                                <Col md={servicio === '1' ? 9 : 6}>
                                    <div className={labelClass} style={labelStyle}>Nombre del Producto</div>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        name="vNombreProducto"
                                        type="text"
                                        value={datos.vNombreProducto}
                                        onChange={handleChange}
                                        placeholder="Nombre del producto"
                                    />
                                </Col>
                                {servicio !== '1' && (
                                    <Col md={3}>
                                        <div className={labelClass} style={labelStyle}>Existencia</div>
                                        <Form.Control
                                            size="sm"
                                            type="number"
                                            min="1"
                                            value={existencia}
                                            disabled={servicio === ''}
                                            onChange={(e) => setDExistencia(e.target.value)}
                                            placeholder="0"
                                        />
                                    </Col>
                                )}
                                <Col md={3}>
                                    <div className={labelClass} style={labelStyle}>Disponibilidad</div>
                                    <Form.Select size="sm" value={esActivo} onChange={(e) => setEsActivo(e.target.value)}>
                                        <option value=''>—</option>
                                        <option value="1">Disponible</option>
                                        <option value="0">No disponible</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            {/* Fila 2: Código de Barras | Tipo Producto | Tipo Servicio */}
                            <Row className="g-3 mt-0">
                                <Col md={4}>
                                    <div className={labelClass} style={labelStyle}>Código de Barras</div>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        name="vCodigoBarras"
                                        value={datos.vCodigoBarras}
                                        onChange={handleChange}
                                        placeholder="GTIN-13 / EAN"
                                    />
                                </Col>
                                <Col md={5}>
                                    <div className={labelClass} style={labelStyle}>Tipo de Producto</div>
                                    <Form.Select size="sm" value={datos.idCatTipoProducto || ''} onChange={handleChangeTipoProducto} name="idCatTipoProducto">
                                        <option value=''>Seleccionar</option>
                                        {catTiposProducto.map(tipo => (
                                            <option key={tipo.idCatTipoProducto} value={tipo.idCatTipoProducto}>
                                                {tipo.vDescripcion}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <div className={labelClass} style={labelStyle}>Servicio/Inventariado</div>
                                    <Form.Select
                                        size="sm"
                                        value={servicio}
                                        onChange={(e) => {
                                            setServicio(e.target.value);
                                            if (e.target.value === '1') setDExistencia(0);
                                            else setDExistencia(datos ? datos.dExistencia : 0);
                                        }}
                                    >
                                        <option value=''>Seleccionar</option>
                                        <option value="1">Servicio</option>
                                        <option value="0">Inventariada</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            {/* Fila 3: Tipo Factor IVA | Tasa/Cuota | Comisión */}
                            <Row className="g-3 mt-0">
                                <Col md={4}>
                                    <div className={labelClass} style={labelStyle}>Tipo de Factor IVA</div>
                                    <Form.Select
                                        size="sm"
                                        value={datos.vTipoFactorIVA}
                                        onChange={(e) => {
                                            const nf = e.target.value;
                                            setDatos(prev => ({ ...prev, vTipoFactorIVA: nf }));
                                            setTasaCuotaIVA(0);
                                            calculaImpuestos(nf, datos.dTotal, 0);
                                            calcularRenovacionesDesdeTasaCuota(nf, 0);
                                        }}
                                    >
                                        <option value=''>Seleccionar</option>
                                        <option value='Exento'>Exento</option>
                                        <option value='Tasa'>Tasa</option>
                                        <option value='Cuota'>Cuota</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <div className={labelClass} style={labelStyle}>Tasa o Cuota IVA</div>
                                    <Form.Control
                                        size="sm"
                                        type="number"
                                        step="any"
                                        min="0"
                                        value={tasaCuotaIVA}
                                        disabled={datos.vTipoFactorIVA === '' || datos.vTipoFactorIVA === 'Exento'}
                                        isInvalid={!!errorTasaCuota}
                                        onChange={(e) => {
                                            const v = parseFloat(e.target.value);
                                            if (datos.vTipoFactorIVA === 'Tasa' && v > 1) {
                                                setErrorTasaCuota('La tasa debe estar entre 0 y 1 (ej. 0.16)');
                                                return;
                                            }
                                            if (datos.vTipoFactorIVA === 'Cuota' && v > 1000) {
                                                setErrorTasaCuota('La cuota no puede ser mayor a 1000');
                                                return;
                                            }
                                            setErrorTasaCuota('');
                                            tasaCuota(e);
                                        }}
                                        placeholder={datos.vTipoFactorIVA === 'Tasa' ? '0.16' : '0'}
                                    />
                                    {errorTasaCuota && (
                                        <div className="text-danger mt-1" style={{ fontSize: '0.71rem' }}>
                                            {errorTasaCuota}
                                        </div>
                                    )}
                                </Col>
                                <Col md={5}>
                                    <div className={labelClass} style={labelStyle}>Comisión</div>
                                    <Form.Select size="sm" value={datos.idCatDepartamento} name="idCatDepartamento" onChange={handleChange}>
                                        <option value=''>Seleccionar</option>
                                        <option value='0'>Sin Comisión</option>
                                        <option value='1'>Comisión</option>
                                        <option value='2'>Comisión Parcial 30%</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            {/* Fila 4: Campos condicionales */}
                            {(datos.vTipoProducto === 'Licencia' || datos.vTipoProducto === 'ModuloExtra' || datos.vTipoProducto === 'PlanFacturacionMx') && (
                                <Row className="g-3 mt-0">
                                    {datos.vTipoProducto === 'Licencia' && (
                                        <Col md={5}>
                                            <div className={labelClass} style={labelStyle}>Tipo de Licencia</div>
                                            <Form.Select
                                                size="sm"
                                                value={datos.idCatTipoLicencia || ''}
                                                name="idCatTipoLicencia"
                                                onChange={(e) => setDatos(prev => ({ ...prev, idCatTipoLicencia: e.target.value ? parseInt(e.target.value) : null }))}
                                            >
                                                <option value=''>Seleccionar tipo</option>
                                                {tiposLicencia.map((tipo) => (
                                                    <option key={tipo.idCatTipoLicencia} value={tipo.idCatTipoLicencia}>
                                                        {tipo.vDescripcionTipo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                    )}
                                    {datos.vTipoProducto === 'ModuloExtra' && (
                                        <Col md={6}>
                                            <div className={labelClass} style={labelStyle}>Módulo Vinculado</div>
                                            <div style={{ position: 'relative' }}>
                                                <Form.Control
                                                    size="sm"
                                                    placeholder="Buscar módulo..."
                                                    value={moduloBusqueda}
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        setModuloBusqueda(v);
                                                        setShowModuloDropdown(true);
                                                        if (!v) { setDatos(prev => ({ ...prev, idCatModulo: null })); setModuloSeleccionado(null); }
                                                        setModulosDropdown([]);
                                                        if (debounceRefModulo.current) clearTimeout(debounceRefModulo.current);
                                                        debounceRefModulo.current = setTimeout(() => cargarModulosDropdown(v, 1, false), 300);
                                                    }}
                                                    onFocus={() => {
                                                        setShowModuloDropdown(true);
                                                        if (modulosDropdown.length === 0) cargarModulosDropdown(moduloBusqueda, 1, false);
                                                    }}
                                                    onBlur={() => setTimeout(() => setShowModuloDropdown(false), 150)}
                                                />
                                                {datos.idCatModulo && !showModuloDropdown && (
                                                    <div className="mt-1 d-flex align-items-center gap-2">
                                                        <span className="badge bg-soft-primary text-primary" style={{ fontSize: '0.7rem' }}>
                                                            {moduloSeleccionado?.vClaveModulo}
                                                        </span>
                                                        <small className="text-muted">{moduloSeleccionado?.vDescripcionModulo}</small>
                                                        <button type="button" className="btn-close" style={{ fontSize: '0.6rem' }}
                                                            onClick={() => { setDatos(prev => ({ ...prev, idCatModulo: null })); setModuloSeleccionado(null); setModuloBusqueda(''); }} />
                                                    </div>
                                                )}
                                                {showModuloDropdown && (
                                                    <div style={{ position: 'absolute', zIndex: 1000, width: '100%', background: 'white', border: '1px solid #dee2e6', borderRadius: '0.375rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                                                        {/* Deshabilitado para no crear módulos desde aquí
                                                        <div className="px-3 py-2 border-bottom" style={{ cursor: 'pointer', color: '#0d6efd', background: 'white' }}
                                                            onMouseDown={() => { setShowCrearModulo(true); setShowModuloDropdown(false); }}>
                                                            <i className="bi bi-plus-circle me-1" />Crear nuevo módulo...
                                                        </div>
                                                        */}
                                                        <div
                                                            style={{ maxHeight: '180px', overflowY: 'auto' }}
                                                            onScroll={(e) => {
                                                                const { scrollTop, clientHeight, scrollHeight } = e.target;
                                                                if (scrollHeight - scrollTop - clientHeight < 30 && modulosHayMas && !cargandoModulos) {
                                                                    cargarModulosDropdown(moduloBusqueda, modulosPagina + 1, true);
                                                                }
                                                            }}
                                                        >
                                                            {modulosDropdown.map(mod => (
                                                                <div key={mod.idCatModulo} className="px-3 py-2 d-flex align-items-center justify-content-between" style={{ cursor: 'pointer' }}>
                                                                    <div className="flex-grow-1 min-w-0"
                                                                        onMouseDown={() => { setDatos(prev => ({ ...prev, idCatModulo: mod.idCatModulo, vClaveModulo: mod.vClaveModulo })); setModuloSeleccionado(mod); setModuloBusqueda(mod.vDescripcionModulo); setShowModuloDropdown(false); }}>
                                                                        <span className="badge bg-soft-secondary text-secondary me-2" style={{ fontSize: '0.65rem' }}>{mod.vClaveModulo}</span>
                                                                        {mod.vDescripcionModulo}
                                                                    </div>
                                                                    {/* Deshabilitado para no borrar módulos
                                                                    <button type="button" className="btn btn-link p-0 ms-2 text-danger" style={{ fontSize: '0.7rem', lineHeight: 1, flexShrink: 0 }}
                                                                        onMouseDown={(e) => { e.stopPropagation(); setModuloAEliminar(mod); setShowModuloDropdown(false); }}>
                                                                        <i className="bi bi-trash" />
                                                                    </button>
                                                                    */}
                                                                </div>
                                                            ))}
                                                            {cargandoModulos && (
                                                                <div className="text-center py-2">
                                                                    <span className="spinner-border spinner-border-sm text-secondary" />
                                                                </div>
                                                            )}
                                                            {!cargandoModulos && modulosDropdown.length === 0 && (
                                                                <div className="px-3 py-2 text-muted" style={{ fontSize: '0.85rem' }}>Sin resultados</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {showCrearModulo && (
                                                <div className="mt-2 p-2 border rounded" style={{ background: '#f8f9fa' }}>
                                                    <div className="fw-semibold mb-2" style={{ fontSize: '0.8rem' }}>Nuevo módulo</div>
                                                    <Form.Control size="sm" className="mb-2" placeholder="Clave (ej. MOD-FACTURACION-MX)"
                                                        value={nuevoModuloForm.vClaveModulo}
                                                        onChange={(e) => setNuevoModuloForm(prev => ({ ...prev, vClaveModulo: e.target.value.toUpperCase().replace(/[^A-Z0-9-_]/g, '') }))} />
                                                    <Form.Control size="sm" className="mb-2" placeholder="Descripción del módulo"
                                                        value={nuevoModuloForm.vDescripcionModulo}
                                                        onChange={(e) => setNuevoModuloForm(prev => ({ ...prev, vDescripcionModulo: e.target.value }))} />
                                                    <div className="d-flex gap-2">
                                                        <Button size="sm" variant="primary" onClick={crearModuloRapido} disabled={guardandoModulo}>
                                                            {guardandoModulo ? <><span className="spinner-border spinner-border-sm me-1" />Guardando...</> : 'Crear'}
                                                        </Button>
                                                        <Button size="sm" variant="outline-secondary" onClick={() => { setShowCrearModulo(false); setNuevoModuloForm({ vClaveModulo: '', vDescripcionModulo: '' }); }}>
                                                            Cancelar
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                    )}
                                    {datos.vTipoProducto === 'ModuloExtra' && (
                                        <Col md={5}>
                                            <div className={labelClass} style={labelStyle}>Tipo de Licencia</div>
                                            <Form.Select
                                                size="sm"
                                                value={datos.idCatTipoLicencia || ''}
                                                name="idCatTipoLicencia"
                                                onChange={(e) => setDatos(prev => ({ ...prev, idCatTipoLicencia: e.target.value ? parseInt(e.target.value) : null }))}
                                            >
                                                <option value=''>Sin tipo de licencia</option>
                                                {tiposLicencia.map((tipo) => (
                                                    <option key={tipo.idCatTipoLicencia} value={tipo.idCatTipoLicencia}>
                                                        {tipo.vDescripcionTipo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                    )}
                                    {datos.vTipoProducto === 'PlanFacturacionMx' && (
                                        <Col md={3}>
                                            <div className={labelClass} style={labelStyle}>Cantidad de Timbres</div>
                                            <Form.Control
                                                size="sm"
                                                type="text"
                                                value={datos.iCantidadTimbres}
                                                onChange={handleChangeCantidadTimbres}
                                                name="iCantidadTimbres"
                                                placeholder="Ej. 200"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                            />
                                        </Col>
                                    )}
                                </Row>
                            )}

                            {/* Fila 5: Canal del Producto */}
                            <Row className="g-3 mt-0">
                                <Col md={12}>
                                    <div className={labelClass} style={labelStyle}>Canal del Producto</div>
                                    <Form.Select
                                        size="sm"
                                        value={datos.iCanalProducto}
                                        name="iCanalProducto"
                                        onChange={(e) => setDatos(prev => ({ ...prev, iCanalProducto: e.target.value }))}
                                    >
                                        <option value="0">Producto General</option>
                                        <option value="1">Licencia de AkasiaPOS</option>
                                        <option value="2">Licencia Nube (Desktop)</option>
                                    </Form.Select>
                                    <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                                        Identifica el canal o contexto donde el producto es utilizado o mostrado
                                    </Form.Text>
                                    {datos.iCanalProducto === "2" && (
                                        <div className="mt-2 p-2 rounded border bg-white shadow-sm" style={{ fontSize: '0.8rem', lineHeight: 1.35 }}>
                                            <div className="d-flex align-items-start gap-2">
                                                <div className="text-primary" style={{ fontSize: '1.1rem' }}><i className="bi bi-display-fill"></i></div>
                                                <div>
                                                    <div style={{ fontWeight: 600, marginBottom: 4 }}>Desktop</div>
                                                    <div className="text-muted">Si eliges esta opción, el producto aparecerá en la aplicación Desktop. Será necesario programar la ventana de marketing para mostrarlo en la interfaz del Desktop.</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {datos.iCanalProducto === "1" && (
                                        <div className="mt-2 p-2 rounded border bg-white shadow-sm" style={{ fontSize: '0.8rem', lineHeight: 1.35 }}>
                                            <div className="d-flex align-items-start gap-2">
                                                <div className="text-success" style={{ fontSize: '1.1rem' }}><i className="bi bi-cart-fill"></i></div>
                                                <div>
                                                    <div style={{ fontWeight: 600, marginBottom: 4 }}>AkasiaPOS</div>
                                                    <div className="text-muted">Si eliges esta opción, el producto estará disponible en la sección de compra de planes dentro de AkasiaPOS. Requiere programar la integración para que los usuarios puedan adquirirlo desde la app.</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                        </Card.Body>
                    </Card>

                    {/* Estructura de Precios */}
                    <Card className="shadow-sm">
                        <Card.Header className="py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                <i className="bi bi-tags me-2 text-primary" />
                                Estructura de Precios
                            </span>
                            <Nav variant="tabs" className="border-0" style={{ marginBottom: '-9px' }}>
                                <Nav.Item>
                                    <Nav.Link
                                        active={tabMoneda === 'MXN'}
                                        onClick={() => setTabMoneda('MXN')}
                                        className="py-1 px-3"
                                        style={{ cursor: 'pointer', fontSize: '0.8rem' }}
                                    >
                                        MXN
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link
                                        active={tabMoneda === 'USD'}
                                        onClick={() => setTabMoneda('USD')}
                                        className="py-1 px-3"
                                        style={{ cursor: 'pointer', fontSize: '0.8rem' }}
                                    >
                                        USD
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {/* Switch para Activar Descuentos por Días de Renovación (Solo visible en Póliza) */}
                            {(datos.vTipoProducto === 'Poliza' || datos.vTipoProducto === 'Póliza') && (
                                <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded border">
                                    <div>
                                        <span className="fw-semibold d-block" style={{ fontSize: '0.82rem' }}>
                                            <i className="bi bi-percent me-2 text-success" />
                                            Descuentos por Pronta Renovación (por Días)
                                        </span>
                                        <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                            Habilita la configuración de descuentos según los días antes del vencimiento.
                                        </small>
                                    </div>
                                    <Form.Check
                                        type="switch"
                                        id="switch-descuento-por-dias"
                                        checked={datos.bDescuentoPorDias || false}
                                        onChange={(e) => setDatos({ ...datos, bDescuentoPorDias: e.target.checked })}
                                    />
                                </div>
                            )}

                            {/* Checkboxes horizontales */}
                            <div className="d-flex flex-wrap gap-4 pb-3 mb-3 border-bottom">
                                {datos.precios
                                    .filter(p => p.vMoneda === tabMoneda)
                                    .map(precio => (
                                        <Form.Check
                                            key={`chk-${precio.vMoneda}-${precio.idCatTipoPrecio}`}
                                            type="checkbox"
                                            id={`chk-${precio.vMoneda}-${precio.idCatTipoPrecio}`}
                                            label={precio.descripcion}
                                            checked={precio.activo}
                                            onChange={() => handleTogglePrecio(precio.vMoneda, precio.idCatTipoPrecio)}
                                        />
                                    ))
                                }
                            </div>

                            {/* Tabla de configuración de precios activos */}
                            {datos.precios.filter(p => p.vMoneda === tabMoneda && p.activo).length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-sm align-middle mb-0" style={{ fontSize: '0.82rem' }}>
                                        <thead>
                                            <tr>
                                                <th className={`border-0 pb-2 ${labelClass}`} style={labelStyle}>Configuración</th>
                                                <th className={`border-0 pb-2 ${labelClass}`} style={labelStyle}>Precio Unitario</th>
                                                <th className={`border-0 pb-2 ${labelClass}`} style={{ ...labelStyle, minWidth: '160px' }}>Total (con IVA)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {datos.precios
                                                .filter(p => p.vMoneda === tabMoneda && p.activo)
                                                .map(precio => {
                                                    const total = parseFloat(precio.dTotal) || 0;
                                                    const tasa = parseFloat(tasaCuotaIVA) || 0;
                                                    let base = total;
                                                    if (datos.vTipoFactorIVA === 'Tasa' && tasa > 0) base = total / (1 + tasa);
                                                    else if (datos.vTipoFactorIVA === 'Cuota') base = total - tasa;
                                                    return (
                                                        <tr key={`row-${precio.vMoneda}-${precio.idCatTipoPrecio}`}>
                                                            <td>
                                                                <span className="badge bg-primary" style={{ fontSize: '0.72rem', fontWeight: 500 }}>
                                                                    {precio.descripcion}
                                                                </span>
                                                            </td>
                                                            <td className="text-muted" style={{ fontSize: '0.8rem' }}>
                                                                {total > 0 ? `${tabMoneda} ${base.toFixed(2)}` : <span className="text-400">—</span>}
                                                            </td>
                                                            <td>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text">{tabMoneda}</span>
                                                                    <Form.Control
                                                                        type="number"
                                                                        min="0.01"
                                                                        step="0.01"
                                                                        placeholder="0.00"
                                                                        value={precio.dTotal}
                                                                        onChange={e => handlePrecioChange(precio.vMoneda, precio.idCatTipoPrecio, e.target.value)}
                                                                    />
                                                                    {(datos.vTipoProducto === 'Poliza' || datos.vTipoProducto === 'Póliza') && (
                                                                        <Button
                                                                            variant={datos.bDescuentoPorDias ? "outline-primary" : "outline-secondary"}
                                                                            size="sm"
                                                                            disabled={!datos.bDescuentoPorDias}
                                                                            onClick={(e) => { e.stopPropagation(); handleAbrirDescuentos(precio); }}
                                                                            title={datos.bDescuentoPorDias ? "Configurar Descuentos por Días" : "Activa los Descuentos por Días arriba para configurar"}
                                                                        >
                                                                            <i className="bi bi-percent" />
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center py-4 text-muted" style={{ fontSize: '0.82rem' }}>
                                    <i className="bi bi-tag me-2 opacity-50" />
                                    Activa al menos un tipo de precio para continuar.
                                </div>
                            )}

                        </Card.Body>
                    </Card>

                </Col>
            </Row>



            <BuscadorSatModal
                show={showBuscadorProducto}
                onHide={() => setShowBuscadorProducto(false)}
                onSelect={(item) => {
                    actualizarCodigoProd('vCodigoProductoServicioSat', item.codigo);
                    setClaveDescripcion(item.descripcion);
                    setValidarCodigo({ validadoCodigoSat: true, validandoCodigoSat: false });
                    setShowBuscadorProducto(false);
                }}
                tipo="producto"
            />

            <BuscadorSatModal
                show={showBuscadorUnidad}
                onHide={() => setShowBuscadorUnidad(false)}
                onSelect={(item) => {
                    actualizarClaveUnidad('vClaveUnidadSat', item.codigo);
                    setValidarClave({ validadoClaveUnidad: true, validandoClaveUnidad: false });
                    setShowBuscadorUnidad(false);
                }}
                tipo="unidad"
            />
            {/* Modal confirmar eliminar módulo */}
            <Modal show={!!moduloAEliminar} onHide={() => setModuloAEliminar(null)} centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1rem' }}>Eliminar módulo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Eliminar <strong>{moduloAEliminar?.vDescripcionModulo}</strong>? Esta acción no se puede deshacer.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setModuloAEliminar(null)} disabled={eliminandoModulo}>
                        Cancelar
                    </Button>
                    <Button variant="danger" size="sm" onClick={eliminarModulo} disabled={eliminandoModulo}>
                        {eliminandoModulo ? <><Spinner size="sm" className="me-1" />Eliminando...</> : 'Eliminar'}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showDescuentosModal} onHide={() => setShowDescuentosModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1.1rem' }}>
                        Descuentos por Pronta Renovación - {descuentoPrecioSeleccionado?.descripcion} ({descuentoPrecioSeleccionado?.vMoneda})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-info py-2" style={{ fontSize: '0.85rem' }}>
                        <i className="bi bi-info-circle-fill me-2"></i>
                        El precio base configurado es de <strong>{descuentoPrecioSeleccionado?.vMoneda} {descuentoPrecioSeleccionado?.dTotal || '0.00'}</strong>. 
                        Modifica el precio con descuento o el porcentaje y se calculará automáticamente el otro valor.
                    </div>
                    
                    {descuentosConfig.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            <p className="mb-0">No hay configuraciones de descuento. Haz clic en "Agregar regla" para comenzar.</p>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm align-middle">
                                <thead>
                                    <tr>
                                        <th>Desde (días)</th>
                                        <th>Hasta (días)</th>
                                        <th>Precio</th>
                                        <th>Porcentaje (%)</th>
                                        <th className="text-center">Quitar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {descuentosConfig.map((row, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Form.Control size="sm" type="number" min="0" value={row.diasMin} onChange={e => handleChangeDescuento(index, 'diasMin', e.target.value)} placeholder="Ej. 25" />
                                            </td>
                                            <td>
                                                <Form.Control size="sm" type="number" min="0" value={row.diasMax} onChange={e => handleChangeDescuento(index, 'diasMax', e.target.value)} placeholder="Ej. 30" />
                                            </td>
                                            <td>
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">{descuentoPrecioSeleccionado?.vMoneda}</span>
                                                    <Form.Control size="sm" type="number" min="0" step="0.01" value={row.precio} onChange={e => handleChangeDescuento(index, 'precio', e.target.value)} placeholder="Ej. 95.00" />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="input-group input-group-sm">
                                                    <Form.Control size="sm" type="number" min="0" step="0.01" value={row.porcentaje} onChange={e => handleChangeDescuento(index, 'porcentaje', e.target.value)} placeholder="Ej. 5.00" />
                                                    <span className="input-group-text">%</span>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <Button variant="link" className="text-danger p-0" onClick={() => handleEliminarDescuento(index)}>
                                                    <i className="bi bi-trash" style={{ fontSize: '1.2rem' }}></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    
                    <Button variant="outline-primary" size="sm" onClick={handleAgregarDescuento} className="mt-2">
                        <i className="bi bi-plus-circle me-1"></i> Agregar regla
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowDescuentosModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" size="sm" onClick={handleGuardarDescuentos}>
                        Guardar Configuración
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

AgregarProducto.propTypes = {
    productos: PropTypes.object,
    precios: PropTypes.array,
    hideHeader: PropTypes.bool,
    onSaved: PropTypes.func,
};

export default AgregarProducto;
